import React from "react";
import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./styles.css";

// autoUpdate: a new deploy's worker activates and reloads on the next visit, with no update
// prompt. Single trusted user, no reason for a confirm-to-update dance.
const updateSW = registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (!registration) return;
    // A home-screen PWA is rarely fully closed, so the browser's own update check (on navigation)
    // can go days without running and a deploy never arrives. Check when the app comes back to
    // the foreground instead of on a timer: finding an update reloads the page, and that must not
    // happen while someone is in the middle of watching an aircraft.
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") void registration.update();
    });
  },
});
void updateSW;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
